<template>
  <div style="padding:20px;">
    <!-- 按钮 -->
    <div>
      <el-button type="success">type: success</el-button>
      <el-button type="info">type: info</el-button>
    </div>
    <br>
    <!-- checkbox -->
    <div>
      <el-checkbox v-model="checked">复选</el-checkbox>
      <el-checkbox v-model="checked2" disabled>复选禁用</el-checkbox>
      <el-checkbox v-model="checked3" checked disabled>复选禁用</el-checkbox>
    </div>
    <br>
    <!-- input -->
    <div>
      <el-input v-model="input" placeholder="请输入" size="small"></el-input><br><br>
      <el-input v-model="input1" placeholder="请输入" size="small" disabled></el-input><br><br>
      <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
    </div>
    <br>
    <el-button @click="dialogVisible = true">show dialog</el-button>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible">
      <span>hello</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" size="small" @click="dialogVisible = false">确 定</el-button>
        <el-button type="info" size="small" @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <province-city-area/><br><br>
    <el-table class="kaow-table" width="90%" :data="tableData" stripe>
      <el-table-column type="selection" width="55"/>
      <el-table-column prop="date" label="日期" width="180"/>
      <el-table-column prop="name" label="姓名" width="180"/>
      <el-table-column prop="address" label="地址"/>
    </el-table>
    <br>
    <!-- <el-button @click="alertError">alert error</el-button>
    <el-button @click="alertSuccess">alert success</el-button> -->
    <import-teacher-dialog
      :visible="importDialogVisible"
      :school-id="schoolId"
      :exam-id="examId"
      :subject-id="subjectId"
      :user-id="userId"
      :dispatch-type="dispatchType"
      :div-id="divId"
      @update-visible="handleUpdateVisible"
      @push-imported-teachers="handlePushedTeachers" />
    <el-button @click="showImportTeacher">导入老师</el-button>

    <checkcode-dialog
      :visible="checkcodeDialogVisible"
      mobile="18681550365"
      :mobile-can-edit="false"
      :send-success="sendSuccess"
      @checkcode-dialog-close="handleCheckcodeDialogClose"
      @checkcode-dialog-confirm="handleCheckcodeDialogConfirm">
      <p slot="header-tips">
        在评卷后期，某些机构因客观原因无法完成评卷任务，我们可以开启“快速结束评卷通道”，以便让大家帮助其完成任务。
      </p>
    </checkcode-dialog>
    <el-button @click="showCheckcodeDialog">显示验证码弹窗</el-button>

    <!-- 转班 -->
    <change-class-dialog
      :visible="changeClassDialogVisible"
      org-id="1526981240868"
      @change-class-dialog-close="handleChangeClassDialogClose"
      @change-class-dialog-confirm="handleChangeClassDialogConfirm"/>
    <el-button @click="showChangeClassDialog">显示转班级弹窗</el-button>
  </div>
</template>

<script>
import ProvinceCityArea from '@/components/custom/ProvinceCityArea'
import CheckcodeDialog from '@/components/custom/CheckcodeDialog'
import ImportTeacherDialog from '@/views/exam/task/ImportTeacherDialog'
import ChangeClassDialog from '@/views/class/ChangeClassDialog'

export default {
  name: 'Demo',
  data () {
    return {
      checked: false,
      checked2: false,
      checked3: false,
      input: '',
      input1: '禁止输入',
      options: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      value: '',
      dialogVisible: false,
      importDialogVisible: false,
      checkcodeDialogVisible: false,
      sendSuccess: false,
      schoolId: '123',
      examId: '1525256466061',
      subjectId: '1523870605249',
      userId: '1523870605301',
      dispatchType: '1',
      divId: '123',
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
      changeClassDialogVisible: false
    }
  },
  methods: {
    alertError () {
      this.$alertError({
        // 标记 messages 项的类型, 可缺省, 默认值为 false
        // 如果为 true, messages 项需要传入 vnode 数组
        vnodes: false,
        messages: ['导入失败', '请下载错误文档']
      })
    },
    alertSuccess () {
      this.$alertSuccess({
        // 标记 messages 项的类型, 可缺省, 默认值为 false
        // 如果为 true, messages 项需要传入 vnode 数组
        vnodes: false,
        messages: ['导入成功']
      }, {
        showClose: true,
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定'
      })
    },
    showImportTeacher () {
      this.importDialogVisible = true
    },
    handleUpdateVisible (visible) {
      this.importDialogVisible = visible
    },
    handlePushedTeachers (teachers) {
      console.log(teachers)
    },
    // 验证码弹窗
    showCheckcodeDialog () {
      this.checkcodeDialogVisible = true
    },
    handleCheckcodeDialogClose () {
      this.checkcodeDialogVisible = false
    },
    handleCheckcodeDialogConfirm (params) {
      console.log(params)
    },
    showChangeClassDialog () {
      this.changeClassDialogVisible = true
    },
    handleChangeClassDialogClose () {
      this.changeClassDialogVisible = false
    },
    handleChangeClassDialogConfirm () {
      this.changeClassDialogVisible = false
    }
  },
  components: {
    ProvinceCityArea,
    CheckcodeDialog,
    ImportTeacherDialog,
    ChangeClassDialog
  }
}
</script>

<style lang="scss">
body {
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/demo/Demo.vue